import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-thumb-up",
  templateUrl: "./med-icon-thumb-up.component.html",
})
export class MedIconThumbUpComponent extends SvgMixinComponent {}
